// extracted by mini-css-extract-plugin
export default {"root":"LayoutSideNavigation_root__dJxGM","container":"LayoutSideNavigation_container__PomA0","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__CS0W4"};